import { Stack } from "@mui/material";
import HolidayService from "components/customer-information/preferences/holiday-service/HolidayService";
import { PageTitle } from "components/shared";
import { t } from "i18next";

const HolidayServicePage = () => {
  return (
    <>
      <Stack>
        <PageTitle title={`${t("preferences.detailsTitle")}`} />
        <HolidayService />
      </Stack>
    </>
  );
};

export default HolidayServicePage;
